/* @flow */
// typecheck: ignore file

export default function isAPIError(error: any): boolean {
  return !(error instanceof Error);
}



// WEBPACK FOOTER //
// ./src/lib/isAPIError.js